import PropTypes from 'prop-types';
import React from 'react';
import Link from 'react-router/lib/Link';
import classNames from 'classnames';

const ButtonLink = ({ inHeader, content, link, disabled }) => {
  /*
   * props:
   *   inHeader: optional, boolean shows if this button is in a header
   */

  const linkClass = classNames('c-btn c-btn--medium', {
    'c-header-primary__button': inHeader,
    'no-pointer-events is-disabled': disabled,
  });

  return (
    <Link to={link} className={linkClass}>
      <span className="c-btn__text">{ content }</span>
    </Link>
  );
};

ButtonLink.propTypes = {
  inHeader: PropTypes.bool,
  content: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
};

ButtonLink.defaultProps = {
  inHeader: false,
  disabled: false,
};

export default ButtonLink;
